export default {"src":"/_next/static/media/Rectangle 4497.da44456d.svg","height":8,"width":8,"blurWidth":0,"blurHeight":0};